import CompLayout from "@/pcomponents/comp/layout/layout";
import OrderListCompArea from "@/pages/comp/book_order/shop/order/acommon/list_comp";

function CompBookOrderListPage() {
  return (
    <CompLayout>
      <OrderListCompArea></OrderListCompArea>
    </CompLayout>
  );
}

export default CompBookOrderListPage;